import { useEffect, useState } from 'react';
import { useStripeCard } from './hooks/useStripeCard';
import StripeCardModal from './settings/StripeCardModal';

const BRAND_COLORS = {
  visa: '#1a1f71',
  mastercard: '#eb001b',
  amex: '#007bc1',
  discover: '#ff6600',
  default: '#374151',
};

const styles = {}

/**
 * SavedCardsList
 * Full billing page component: shows saved cards + "Add card" button.
 *
 * Props:
 *   user  { customerId, email, name }
 */
export default function SavedCardsList() {
  const user = {
    email: 'testquan1234@gmail.com',
    name: 'test',
    // customerId: 'cus_UWOQOGMWU0qd1J'
  }
  const [modalOpen, setModalOpen] = useState(false);
  const { cards, fetchCards, setDefault, deleteCard, customerId } = useStripeCard({
    customerId: user.customerId,
    email: user.email,
    name: user.name,
  });

  useEffect(() => {
    if (user.customerId) fetchCards(user.customerId);
  }, [user.customerId, fetchCards]);

  const handleSaved = ({ customerId: cid }) => {
    setModalOpen(false);
    console.log(`fetchCards cid::::`, cid)
    fetchCards(cid);
  };

  return (
    <div className={styles.listWrap}>
      <div className={styles.listHeader}>
        <div>
          <h2 className={styles.listTitle}>Payment methods</h2>
          <p className={styles.listSubtitle}>Manage your saved cards</p>
        </div>
        <button className={styles.addBtn} onClick={() => setModalOpen(true)}>
          + Add card
        </button>
      </div>

      {cards.length === 0 ? (
        <div className={styles.emptyState}>
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#d1d5db" strokeWidth="1.5" strokeLinecap="round">
            <rect x="1" y="4" width="22" height="16" rx="2" /><line x1="1" y1="10" x2="23" y2="10" />
          </svg>
          <p>No saved cards yet</p>
          <button className={styles.addBtn} onClick={() => setModalOpen(true)}>
            Add your first card
          </button>
        </div>
      ) : (
        <ul className={styles.cardList}>
          {cards.map(card => (
            <li key={card.id} className={`${styles.cardItem} ${card.isDefault ? styles.cardItemDefault : ''}`}>
              <div className={styles.cardLeft}>
                <span
                  className={styles.brandBadge}
                  style={{ color: BRAND_COLORS[card.brand] ?? BRAND_COLORS.default }}
                >
                  {card.brand.toUpperCase()}
                </span>
                <div>
                  <p className={styles.cardNumber}>•••• •••• •••• {card.last4}</p>
                  <p className={styles.cardExp}>Expires {card.expMonth}/{card.expYear}</p>
                </div>
              </div>

              <div className={styles.cardActions}>
                {card.isDefault ? (
                  <span className={styles.defaultBadge}>Default</span>
                ) : (
                  <button
                    className={styles.ghostBtn}
                    onClick={() => setDefault(card.id)}
                  >
                    Set default
                  </button>
                )}
                <button
                  className={styles.deleteBtn}
                  onClick={() => deleteCard(card.id)}
                  aria-label="Remove card"
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                    <polyline points="3 6 5 6 21 6" /><path d="M19 6l-1 14H6L5 6" /><path d="M10 11v6" /><path d="M14 11v6" /><path d="M9 6V4h6v2" />
                  </svg>
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}

      <StripeCardModal
        open={modalOpen}
        setOpen={setModalOpen}
        onClose={() => setModalOpen(false)}
        onSaved={handleSaved}
        user={{ ...user, customerId }}
      />
    </div>
  );
}
